import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const t = l((o, r) => /* @__PURE__ */ e.jsx(
  i,
  {
    ref: r,
    ...o,
    image: (s) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8 13a5 5 0 1 1 4-8H9v2h5a1 1 0 0 0 1-1V1h-2v2.101a7 7 0 1 0-.05 9.848l-1.414-1.414A4.98 4.98 0 0 1 8 13",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "RefreshIcon";
export {
  t as RefreshIcon,
  t as default
};
//# sourceMappingURL=index.js.map
